module.exports = __webpack_public_path__ + "static/media/triangle.4d302a23.svg";